module.exports = __webpack_public_path__ + "media/images/universe_landing_pages/hero_banner/component/cleaning-desktop@2x-7ca49d2f0af5676cf08efb70d0fff508.jpg";